import React from 'react';
import BaseCollapse from '@mui/material/Collapse';

const Collapse = (props) => {
  return <BaseCollapse {...props} />;
};

export default Collapse;
